import React from "react";
import classNames from "classnames";

export default ({ children, className = null }) => (
  <div className={classNames({ placeholder: true, [className]: !!className })}>
    {children}
  </div>
);
